<script lang="ts">
const __DsBlock = {
	type: 'input',
	hidden: true,
}
</script>
<script setup lang="ts">
import type { GlobalFileId } from '#layers/data-model/public';
import { defineBlock } from '#layers/block-engine/public';
import { usePrimitiveFormField } from '#layers/forms/public';
import { useDisabledNotice } from '#layers/ui/public';

defineProps<{
	changeLabel?: string;
	removeLabel?: string;
}>();

const model = defineModel<GlobalFileId | null>();

;

const { modelValue, disabled, disabledNotice } = usePrimitiveFormField({}, { model });
const { showDisabledNotice } = useDisabledNotice({ disabled, disabledNotice });
</script>

<template>
	<DTooltip :delay-duration="0" :disabled="!showDisabledNotice" :text="disabledNotice">
		<FileUploadSystemThumbnail v-model="modelValue" :disabled :change-label :remove-label>
			<template v-if="$slots.fallback" #fallback>
				<slot name="fallback" />
			</template>
		</FileUploadSystemThumbnail>
	</DTooltip>
</template>
